import React, { useState } from "react";
import Form from "../../../Components/Form";
import UsersDropdown from "../../../Components/Dropdown/Users/UsersDropdown";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  onMarketmakingTaskFormValuesChange,
  setMarketmakingAddTaskFormValues,
  setMarketmakingIsEditFlag,
  setMarketmakingTaskTableFetchDataFlag,
} from "../../../Features/DeltaHedgeMarketmaking/deltaHedgeMarketmakingSlice";
import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";
import SahraConnections from "../../Sahra/SahraConnections";
import MarketmakingOrderPreviewTable from "../../../Tables/DeltaHedgeMarketmaking/MarketmakingOrderPreviewTable";
import {
  addMarketmakingTask,
  editMarketmakingTask,
} from "../../../Requests/deltaHedgeMarketmaking";
import { toast } from "react-toastify";
import { IAddEditMarketmakingTask } from "../../../Interfaces/deltaHedgeMarketmaking";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import FullScreenLoading from "../../../Components/Loading/FullScreenLoading";
import Modal from "../../../Components/Modal/Modal";
import { getStepInstruments } from "../../../Requests/stepRequests";

enum ModalMode {
  SahraOrderTable,
  OrderPreview,
  Closed,
}

const AddTaskBox = () => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [loading, setLoading] = useState(false);

  const formValues = useAppSelector(
    (store) => store.deltaHedgeMarketmaking.addTaskFormValues
  );
  const isEditFlag = useAppSelector((store) => store.deltaHedgeMarketmaking.isEdit);
  const dispatch = useAppDispatch();

  const changeHandler = (name: string, value: any) => {
    dispatch(onMarketmakingTaskFormValuesChange({ name, value }));
  };

  const getProperFunction = () => {
    if (!isEditFlag) return addMarketmakingTask;
    return editMarketmakingTask;
  };

  const addTaskHandler = () => {
    if (!formValues) return;
    setLoading(true);
    getProperFunction()(formValues)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          setModalMode(ModalMode.Closed);
          dispatch(setMarketmakingTaskTableFetchDataFlag(true));
          dispatch(setMarketmakingIsEditFlag(false));
          dispatch(
            setMarketmakingAddTaskFormValues({
              insId: formValues.insId,
            } as IAddEditMarketmakingTask)
          );
        }
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
      });
  };

  const getSahraUserTable = () => {
    return (
      <div className="flex flex-col justify-start items-center gap-3">
        <SahraConnections
          initialSearchParam={{
            userIds: [formValues?.accountId] as any,
          }}
        />

        <Button onClick={addTaskHandler} text="ثبت" variant="contained" />
      </div>
    );
  };

  const getOrderPreviewTable = () => {
    return (
      <div className="flex flex-col justify-start items-center gap-10">
        <MarketmakingOrderPreviewTable values={formValues} />
        <Button
          onClick={() => {
            setModalMode(ModalMode.SahraOrderTable);
          }}
          text="ثبت"
          variant="contained"
        />
      </div>
    );
  };

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.SahraOrderTable:
        return getSahraUserTable();

      case ModalMode.OrderPreview:
        return getOrderPreviewTable();
    }
  };

  const checkBtnDisabled = () => {
    if (
      !formValues?.accountId ||
      !formValues?.insId ||
      !formValues?.threshold ||
      !formValues?.dailyLockProfitBuy ||
      !formValues?.dailyLockProfitSell
    )
      return true;
    return false;
  };

  const cancelClickHandler = () => {
    dispatch(setMarketmakingIsEditFlag(false));
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2">
      {loading ? <FullScreenLoading /> : <></>}
      {modalMode !== ModalMode.Closed ? (
        <Modal title={modalMode === ModalMode.SahraOrderTable ? "اتصالات صحرا" : "پیش‌نمایش سفارش"}
          UI={getModalUI()}
          onClose={() => setModalMode(ModalMode.Closed)}
        />
      ) : (
        <></>
      )}
      <DynamicDropdown
        dropdown={{
          name: "insId",
          placeholder: "نماد",
          extraLabel: true,
          disabled: isEditFlag,
        }}
        getData={getStepInstruments}
        onChange={changeHandler}
        value={formValues?.insId}
      />

      <UsersDropdown
        label="نام اکانت"
        name="accountId"
        value={formValues?.accountId}
        onChange={changeHandler}
        extraLabel
        disabled={isEditFlag}
      />

      <TextInput
        label="% بازده قفل روزانه خرید"
        name="dailyLockProfitBuy"
        value={formValues?.dailyLockProfitBuy?.toString()}
        onChange={changeHandler}
        // kind="percent"
        extraLabel
      />
      <TextInput
        label="% بازده قفل روزانه فروش"
        name="dailyLockProfitSell"
        value={formValues?.dailyLockProfitSell?.toString()}
        onChange={changeHandler}
        // kind="percent"
        extraLabel
      />

      <TextInput
        label="آستانه تغییر (درصد)"
        name="threshold"
        value={formValues?.threshold?.toString()}
        onChange={changeHandler}
        // kind="percent"
        extraLabel
      />

      <Button
        onClick={() => {
          setModalMode(ModalMode.OrderPreview);
        }}
        text="ثبت"
        variant="contained"
        disabled={checkBtnDisabled()}
      />
      {isEditFlag ? (
        <Button onClick={cancelClickHandler} text="انصراف" variant="outlined" />
      ) : (
        <></>
      )}
    </Form>
  );
};

export default AddTaskBox;
